import {
    Microscope, HandMetal, Target, Workflow, BookOpen, TrendingUp,
    Gauge, ShieldCheck, BarChart3, Flame, Repeat, Moon,
    Brain, ClipboardList, Activity, Footprints, ShieldAlert, HeartPulse,
} from "lucide-react";
import { StaggerGroup, StaggerItem, Reveal } from "@/components/ScrollReveal";
import { CURSUS_COMPETENCIES } from "@/lib/cursusMeta";

const ICONS = {
    Microscope, HandMetal, Target, Workflow, BookOpen, TrendingUp,
    Gauge, ShieldCheck, BarChart3, Flame, Repeat, Moon,
    Brain, ClipboardList, Activity, Footprints, ShieldAlert, HeartPulse,
};

export default function CursusCompetencies({ slug }) {
    const items = CURSUS_COMPETENCIES[slug] || [];
    return (
        <section
            className="relative bg-brand-sand py-24 md:py-36"
            data-testid="cursus-competencies"
        >
            <div className="mx-auto max-w-7xl px-6">
                <div className="max-w-3xl">
                    <Reveal>
                        <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-brand-orange">
                            Compétences acquises
                        </span>
                        <h2 className="mt-5 font-display font-normal leading-[0.95] tracking-tightest text-brand-ink text-[40px] sm:text-5xl lg:text-[72px]">
                            Ce que vous allez <em className="italic text-brand-smoke">maîtriser.</em>
                        </h2>
                        <p className="mt-6 max-w-xl text-base leading-relaxed text-brand-ink/70">
                            Six compétences-clés, travaillées en profondeur, que vous intégrerez dès votre retour en cabinet.
                        </p>
                    </Reveal>
                </div>

                <StaggerGroup stagger={0.08} className="mt-16 grid grid-cols-1 gap-x-10 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
                    {items.map((c, i) => {
                        const Icon = ICONS[c.icon] || Microscope;
                        return (
                            <StaggerItem key={c.title}>
                                <div
                                    className="group relative"
                                    data-testid={`competency-${i + 1}`}
                                >
                                    <div className="flex items-start gap-4">
                                        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-brand-orange/15 text-brand-orange transition-all duration-500 group-hover:scale-110 group-hover:rotate-3">
                                            <Icon className="h-5 w-5" />
                                        </div>
                                        <div>
                                            <div className="font-display text-xl leading-tight text-brand-ink">
                                                {c.title}
                                            </div>
                                            <div className="mt-3 text-sm leading-relaxed text-brand-ink/65">
                                                {c.text}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-6 h-px w-10 bg-brand-orange/60 transition-all duration-500 group-hover:w-20" />
                                </div>
                            </StaggerItem>
                        );
                    })}
                </StaggerGroup>
            </div>
        </section>
    );
}
